module.exports = __webpack_public_path__ + "static/media/black.b4adfbf3.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/CSS/assets-minified/dummy-images/poly/black.jpeg
// module id = ./src/CSS/assets-minified/dummy-images/poly/black.jpeg
// module chunks = 0